import { KennitalaInput, useKennitalaValidation } from '@landsbankinn/ui';
import React from 'react';

interface IProps {
  kennitalaNotFound: boolean;
  kennitala: string;
  setKennitala: (email: string) => void;
  label?: string;
}

export function Kennitala({
  kennitala,
  setKennitala,
  label,
  kennitalaNotFound,
}: IProps) {
  const [ref, isValid, message] = useKennitalaValidation(kennitala);
  return (
    <KennitalaInput
      inputRef={ref}
      isValid={isValid && !kennitalaNotFound}
      errorMessage={message || (kennitalaNotFound ? 'Kennitala ekki til' : '')}
      label={label ?? 'Kennitala'}
      value={kennitala}
      onValueChange={(kennitala) => setKennitala(kennitala.value)}
      variant="noBorder"
      labelVariant="aboveInput"
    />
  );
}
